import { IntlProvider as ReactIntlProvider } from 'react-intl';

import BGlang from 'src/locale/bg/lang.json';
import ENlang from 'src/locale/en/lang.json';
import { storage } from 'src/utils/storage';

type i18n = {
    locale: string;
    messages: { [id: string]: string };
};

const getLocaleMessages = (locale: string) => {
    switch (locale) {
        case 'bg':
            return BGlang;
        case 'en':
            return ENlang;
        default:
            return BGlang;
    }
};

type IntlProviderProps = {
    children?: React.ReactNode;
};

const IntlProvider = ({ children }: IntlProviderProps) => {
    // We check if localStorage holds a language preference, if not we default to bulgarian for now...
    const localLanguage = storage.getLanguage()?.split('-')[0]; // ?? navigator.language.split('-')[0];

    const i18n: i18n = {
        locale: localLanguage,
        messages: getLocaleMessages(localLanguage),
    };

    return (
        <ReactIntlProvider locale={i18n.locale} messages={i18n.messages}>
            {children as any}
        </ReactIntlProvider>
    );
};

export { IntlProvider };
